<div class="row mb-3 align-items-center justify-content-between">
  <div class="col-auto">
    <h1 class="display-4">{{title}}</h1>
  </div>
  <div *ngIf="goTo" class="col-12 col-md-6 col-xl-3">
    <dx-go-to-input></dx-go-to-input>
  </div>
</div>
